import clsx from 'clsx';
import type { FC, PropsWithChildren } from 'react';

interface IProps {
  isExpanded: boolean;
  isTransparent?: boolean;
  className?: string;
  maxHeightWhenOpen?: string;
  zIndex?: number;
}

const DropdownPanel: FC<PropsWithChildren<IProps>> = ({
  isExpanded,
  isTransparent,
  className = '',
  maxHeightWhenOpen = 'max-h-[50vh]',
  zIndex = 10,
  children,
}) => (
  <div className="relative">
    <div className="absolute w-full" style={{ zIndex }}>
      <div
        className={clsx(
          'overflow-x-hidden rounded-xs transition-all duration-300 ease-in-out',
          !isTransparent && 'gray-box',
          isExpanded
            ? `${maxHeightWhenOpen} overflow-y-auto`
            : 'max-h-0 overflow-y-hidden',
          className,
        )}
      >
        {children}
      </div>
    </div>
  </div>
);

export default DropdownPanel;
